<template lang="pug">
div
  .sidebarPersonalitation-backdrop(:class="{ active: isOpen }" @click="closeSidebar")

  .vertical-menu.sidebarPersonalitation-menu(:class="{ active: isOpen }")
    .sidebarPersonalitation-close-header
      button.sidebarPersonalitation-close-btn(@click="closeSidebar")
        i.fas.fa-times

    h3(id="lateral_menu_title")
      | {{title}}

    ul.nav.pl-3(id="menuContainer")
      li(v-for="item in menuItems" :key="item.name" :class="item.class")
        a.nav-link(:href="item.url")
          span(:data-cy="'sidebar-item-' + item.name")
            | {{t(`menu.user_subscription.${item.name}`)}}
            div(v-if="item.svg_icon")
              img(:src="getImgUrl(item.svg_icon)")

    a.per_exit(:href="url_for_user_subscription_log_out()")
      | {{t("menu.user_subscription.logout")}}
      i.fas.fa-sign-out-alt
</template>

<script>
import mixins from "common/mixins"

export default {
  mixins: [mixins.translate, mixins.requests],
  name: "user-subscription-lateral-menu-vue",
  props: {
    menuItems: { type: Array, default: () => [] },
    title: { type: String, default: '' }
  },
  data() {
    return {
      isOpen: false
    }
  },
  methods: {
    getImgUrl(imgName) {
      return require('../../../assets/images/'+ imgName )
    },
    toggleSidebar() {
      this.isOpen = !this.isOpen
      this.toggleBodyScroll()
      window.dispatchEvent(new CustomEvent('sidebar-state-changed', { detail: { isOpen: this.isOpen } }))
    },
    openSidebar() {
      this.isOpen = true
      this.toggleBodyScroll()
      window.dispatchEvent(new CustomEvent('sidebar-state-changed', { detail: { isOpen: true } }))
    },
    closeSidebar() {
      this.isOpen = false
      this.toggleBodyScroll()
      window.dispatchEvent(new CustomEvent('sidebar-state-changed', { detail: { isOpen: false } }))
    },
    toggleBodyScroll() {
      if (this.isOpen) {
        document.body.style.overflow = 'hidden'
      } else {
        document.body.style.overflow = ''
      }
    },
    handleEscape(e) {
      if (e.key === 'Escape' && this.isOpen) {
        this.closeSidebar()
      }
    },
    handleToggleEvent() {
      this.toggleSidebar()
    }
  },
  mounted() {
    document.addEventListener('keydown', this.handleEscape)
    window.addEventListener('toggle-sidebar', this.handleToggleEvent)
  },
  beforeUnmount() {
    document.removeEventListener('keydown', this.handleEscape)
    window.removeEventListener('toggle-sidebar', this.handleToggleEvent)
    document.body.style.overflow = ''
  }
}

</script>